<mat-card appearance="outlined" class="card-widget marB8 card-div">
  <div class="col-12">
    <label class="mainBodyTxt3 GreyLight d-block" [attr.name]="title" name="title">{{ title }}</label>
    <hr class="marT8" style="border-color: black" />
    <div class="row">
      <div class="col-4">
        <mat-card-content>
          <h2 class="h2Header GreyDarkest" id="{{ title }}total">{{ data?.total }}</h2>
          <span class="mainBodyTxt4 GreyLight d-block marT4" id="{{ title }}totalTitle">Total</span>
        </mat-card-content>
      </div>
      <div class="col-4" style="border: 0px 1px 0px 1px solid #efefef">
        <mat-card-content>
          <h2 class="h2Header GreyDarkest" id="{{ title }}backlog">{{ data?.backlog }}</h2>
          <span class="mainBodyTxt4 GreyLight d-block marT4" id="{{ title }}backlogTitle">Backlog</span>
        </mat-card-content>
      </div>
      <div class="col-4">
        <mat-card-content>
          <h2 class="h2Header GreyDarkest" id="{{ title }}fresh">{{ data?.fresh }}</h2>
          <span class="mainBodyTxt4 GreyLight d-block marT4" id="{{ title }}freshTitle">Fresh</span>
        </mat-card-content>
      </div>
    </div>
  </div>
</mat-card>
